import { render, staticRenderFns } from "./PresentationButtons.vue?vue&type=template&id=59fb4274&scoped=true&"
import script from "./PresentationButtons.vue?vue&type=script&lang=js&"
export * from "./PresentationButtons.vue?vue&type=script&lang=js&"
import style0 from "./PresentationButtons.vue?vue&type=style&index=0&id=59fb4274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fb4274",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
